import {DataGrid} from "@mui/x-data-grid";
import { Paper, Typography, Button, Modal} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import GetRole from "./user";
import {useEffect, useState} from "react"
import {CSVLink} from "react-csv"
import { fetchEmployees,loadattendance } from "../api/customerapi";
import { useAppData } from "./appDataContext.js";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(20),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      justifyContent: "center",
    },
}));

const Listemployeedata = () => {

const classes = useStyles();
const width = window.innerWidth-200;
const { appData, loading } = useAppData();
var {cuser, role}=GetRole();
const [showall, setshowall] = useState(0);
const columns = [
    { field: 'employee_id', 
  headerName: ' Employee ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
    { field: 'employee_name', 
    headerName: ' Employee Name', 
    width: width/12*3,
    cellClassName: "gridcell"
    //align:"center",
    //headerAlign:"center"
    },
    {
      field: 'employee_contact',
      headerName: 'Contact',
      width: width/12*2,
      
    },
    {
      field: 'employee_email',
      headerName: 'Email',
      width: width/12*3,
    },
    {
      field: 'role',
      headerName: 'Role',
      width: width/12,
    },
    {
      field: 'manager',
      headerName: 'Manager',
      width: width/12*2,
    },
    {
      field: 'short_name',
      headerName: 'Short Name',
      width: width/12,
    },
    
  ];

  const columns2 = [
    { field: 'employee_id', 
  headerName: ' Employee ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
    { field: 'employee_name', 
    headerName: ' Employee Name', 
    width: width/12*3,
    cellClassName: "gridcell"
    //align:"center",
    //headerAlign:"center"
    },
    {
      field: 'doj',
      headerName: 'DOJ',
      width: width/12,
    },
    {
      field: 'dos',
      headerName: 'DOS',
      width: width/12,
    },
   
    {
      field: 'role',
      headerName: 'Role',
      width: width/12,
    },
    {
      field: 'manager',
      headerName: 'Manager',
      width: width/12*2,
    },
    {
      field: 'dob',
      headerName: 'DOB',
      width: width/12,
    },
    {
      field: 'designation',
      headerName: 'Designation',
      width: width/12,
    },
    
  ];

  const headers=[
    
    {label:"Name", key:"employee_name"},
    {label:"Employee Id", key:"employee_id"},
    {label:"DOJ", key:"doj"},
    {label:"DOS", key:"dos"},
    {label:"Role", key:"role"},
    {label:"Manager", key:"manager"},
  
]
  
  const [listemployeeData, setlistemployeeData] =useState([{
    name: "",
    
    email: "",
    reporting_manager: "",
   }]);
  
  const getEmployees = async () => {
    try{
    const data = await fetchEmployees();
    //console.log(data);
    if(showall){
      setlistemployeeData(data.data)
    }else{
      setlistemployeeData(data.data.filter(emp => emp.role != "Ex-employee"))
    }
    
  }catch(err){
    console.log(err)
  }
  
  }
  
  useEffect(() => {
    getEmployees()
    
  }, [])

  useEffect(() => {
    getEmployees()
    
  }, [showall])

  
  //const [open, setopen] = useState(false);
  //const [modalbody, setmodalbody] = useState("");
  // const currenturl=window.location.href;
    
  //   const [User, setUser] = useState(currenturl);

    
    
      // const handleClose = () => {
      //   setopen(false);
      // };
  
  
  const employeedatalistdisplay=listemployeeData.map(employeedata=>({employee_name: employeedata.name, 
    id:listemployeeData.indexOf(employeedata),
    employee_id:employeedata.employee_id, 
    employee_email:employeedata.email, 
    employee_contact:employeedata.contact, 
    role:employeedata.role,
    manager:employeedata.reporting_manager,
    short_name:employeedata.short_name, 
  }));

    const employeedatalistdisplay2=listemployeeData.map(employeedata=>({employee_name: employeedata.name, 
      id:listemployeeData.indexOf(employeedata),
      employee_id:employeedata.employee_id, 
      dos:employeedata.dos, 
      doj:employeedata.doj, 
      dob:employeedata.dob,
      role:employeedata.role,
      designation:employeedata.designation,
      manager:employeedata.reporting_manager,
      short_name:employeedata.short_name, 
    }));
  //console.log(custdatalistfromdb);

  const gridcelldoubleclick=(id)=>{
   if(role=="Admin" || role=="HR" || cuser=="Tarun" || role=="Manager"){
    window.open("/employeedataentry/"+id, "_blank");
   }
  }

  const loadjetoattendance=async()=>{
    const data=await loadattendance()
    console.log(data.data)
  }



    return ( 
      <div>
        <Paper variant="outlined" className={classes.paper}> 
        <div align="center">
        <Typography variant="h4" align="center" className={classes.headertext}> View Employees</Typography>
        {role=="Admin" || role=="HR"?(
          <Button  variant="contained" color="inherit" align="center" className={classes.button} onClick={()=>setshowall(!showall)}>{showall?"Show Active":"Show All"}</Button>
        ):("")}
        {role=="Admin" || role=="HR"?(
        <Button href="/employeedataentry"  variant="contained" color="primary" align="center" className={classes.button}>Add Employee</Button>):("")}
        {role=="Admin" ?(<Button href="/leadrules"  variant="contained" color="secondary" align="center" className={classes.button}>Set Rules</Button>):("")}
        {/* {role=="Admin" ?(<Button onClick={loadjetoattendance} variant="contained" color="secondary" align="center" className={classes.button}>Attendance</Button>):("")} */}
        </div>
        {/* {open ? <Modal open={open} onClose={handleClose}>abc</Modal> : <Modal open={open} onClose={handleClose}>def</Modal>} */}
        <div style={{ height: 1200, width: '100%' }}>
      <DataGrid rows={employeedatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcelldoubleclick(getValue.row.employee_id)}
        columns={columns}
        autoPageSize
        // pageSize={20}
        // rowHeight={50}
       
        // autoHeight
        >      
      </DataGrid>      
    </div>
    </Paper>
        {role=="Admin" || role=="HR"?(
          <Paper variant="outlined" className={classes.paper}> 
          {employeedatalistdisplay2.length>1?(<div>
                   <CSVLink data={employeedatalistdisplay2} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
          <div style={{ height: 1200, width: '100%' }}>
      <DataGrid rows={employeedatalistdisplay2} 
        onCellDoubleClick={(getValue)=>gridcelldoubleclick(getValue.row.employee_id)}
        columns={columns2}
        autoPageSize
        // pageSize={20}
        // rowHeight={50}
       
        // autoHeight
        >      
      </DataGrid>
      </div>
          </Paper>
        ):("")}
        </div>
     )
}
 
export default Listemployeedata;